import { ProductPanelItem } from '../../../../../types/productpanel/ProductPanelItem';
import QuotationPriceCheckCardItem from './card/QuotationPriceCheckCardItem';
import QuotationPriceCheckListItem from './list/QuotationPriceCheckListItem';


interface Props {
  product: ProductPanelItem;

  mode?: 'card' | 'list';
}

const QuotationPriceCheckItem = ({
  product,
  mode = 'card',
}: Props) => {
  if (mode === 'list') {
    return (
      <QuotationPriceCheckListItem
        product={product}
      />
    );
  }

  return (
    <QuotationPriceCheckCardItem
      product={product}
    />
  );
};

export default QuotationPriceCheckItem;